import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  card: {
    backgroundColor: theme.colorPalette.green_20,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 6, 6)
  },
  label: {
    color: theme.colorPalette.white_30,
    fontWeight: 600,
    fontSize: 10
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  line: {
    margin: theme.spacing(6, 0, -7, 0)
  }
});

export default makeStyles(styles);
